import React from 'react'

/**
 * Render `linearGradient` based in an array of colors
 * and data lengh.
 *
 * If have more data than colors, it start repeating them
 *
 * @param {array} colors
 * @param {number} length
 * @param {string} id
 *
 * @returns {JSX} React Element
 */
const renderLinearGradients = (colors, length, id) => {
  if (!length) return null

  let count = 0
  let gradients = []

  for (let i = 0; i < length; i++) {
    const color = colors[count % colors.length]
    count++
    gradients.push(
      <linearGradient key={`${id}${i}`} id={`${id}${i}`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="5%" stopColor={`${color.to}`} />
        <stop offset="95%" stopColor={`${color.from}`} />
      </linearGradient>
    )
  }

  return <defs>{gradients}</defs>
}

export default renderLinearGradients
